import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5de17aad"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container"
};
const _hoisted_3 = {
  class: "table__container"
};
const _hoisted_4 = {
  class: "cms-card-block"
};
const _hoisted_5 = {
  class: "header__btns"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { getItemByProp, debounce, removePropertyOfNull } from '@/utils/tools';
import { useGenresList, useVodLanguages } from '@/utils/cacheData';
import { getOperatorNameListApi, getUserByCidApi } from '@/api/authority';
import { nextTick, inject, onMounted } from 'vue';
import { elMessage } from '@/utils';
import { useI18n } from 'vue-i18n';
import { useCommon } from '@/store/useCommon';
import { getCurrentTime } from '@/utils/timeFormat';
import { RELEASE_STATUS_NEW, RELEASE_COLOR_NEW, AUDIT_STATUS_NEW, AUDIT_COLOR_NEW } from '@/assets/config/dicts';
import { getReviewListApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: []
    },
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['go-back', 'add-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const brandsList = inject('brandsList');
    const newBrandsList = computed(() => {
      return brandsList.value.map(item => {
        return { ...item,
          disabled: false
        };
      });
    });
    const tableRef = ref();
    const TYPE_OPTION = {
      movie: t('单片'),
      tv_series: t('剧集')
    };
    const CODING_STATUS = {
      0: 'H.264',
      1: 'H.265'
    };
    onMounted(async () => {
      selectTableConfig.selectData = props.selectList; //await getOperatorList();

      getReviewList();
    }); // 标题配置

    const headerConfig = reactive({
      title: '添加影片',
      btnList: [{
        label: '返回',
        func: () => {
          emit('go-back');
        }
      }]
    });
    const dialogConfig = reactive({
      visible: false,
      action: 1,
      config: {
        title: '提示'
      },
      confirm: () => {}
    }); // 搜索查询用额外到的参数

    const searchData = reactive({
      releaseStatus: ''
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        placeholder: '请选择品牌',
        labelKey: 'prefixName',
        valueKey: 'cid',
        list: newBrandsList || [],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getReviewList();
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_SF_BS') > -1;
        },
        disabled: useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS')
      }, {
        label: '关键字',
        prop: 'keyword',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }, {
        label: '分类属性',
        prop: 'genresId',
        widgetType: 'Select',
        placeholder: '请选择分类属性',
        labelKey: 'name',
        valueKey: 'id',
        list: [],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getReviewList();
        }
      }, {
        label: '语言',
        prop: 'language',
        widgetType: 'Select',
        placeholder: '请选择语言',
        valueKey: 'labelValue',
        filterable: true,
        list: [],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getReviewList();
        }
      }, {
        label: '类型',
        prop: 'programType',
        widgetType: 'Select',
        placeholder: '请选择类型',
        list: [{
          label: t('单片'),
          value: 'movie'
        }, {
          label: t('剧集'),
          value: 'tv_series'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          searchConfig.formData.genres = '';
          getGenres();
          getReviewList();
        }
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: t('已上线'),
          value: 'online'
        }, {
          label: t('已下线'),
          value: 'offline'
        }, {
          label: t('未上线'),
          value: 'not_online'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getReviewList();
        }
      }, {
        label: '审核状态',
        prop: 'auditStatus',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: t('已审核'),
          value: 'audited'
        }, {
          label: t('未审核'),
          value: 'unaudited'
        }, {
          label: t('终端审核'),
          value: 'terminal_audit'
        }, {
          label: t('退回审核'),
          value: 'return'
        }, {
          label: t('未通过'),
          value: 'not_approved'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getReviewList();
        }
      }, {
        label: '操作用户',
        prop: 'operatorName',
        widgetType: 'Select',
        filterable: true,
        placeholder: '',
        labelKey: 'agentName',
        valueKey: 'id',
        list: [],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_OU') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getReviewList();
        }
      }, {
        label: '创建时间',
        prop: 'time',
        widgetType: 'date',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        change: debounce(val => {
          tableConfig.paginationConfig.page = 1;
          getReviewList();
        }, 200)
      } // {
      //     label: '运营商', prop: 'cpspid', widgetType: 'treeSelect',
      //     list: [],
      //     controller: () => {
      //         return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
      //     },
      //     change: (val) => {
      //         tableConfig.paginationConfig.page = 1;
      //         getReviewList();
      //     },
      //     props: {
      //         label: 'name',
      //         children: 'children',
      //         value: 'id',
      //     }
      // }
      ],
      formData: {
        cid: Number(sessionStorage.getItem('currentCid')),
        keyword: '',
        genresId: '',
        language: '',
        programType: 'movie',
        time: '',
        codingProtocol: '',
        operatingUser: '',
        auditStatus: '',
        releaseStatus: '',
        cpspId: null
      }
    });
    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      headerButtonsList: [{
        label: '确定添加',
        func: () => {
          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '请先勾选需要添加的影片');
          } else {
            emit('add-list', selectTableConfig.selectData);
          }
        },
        controller: config => {
          config.disabled = !selectTableConfig.selectData.length ? true : false;
          return true;
        }
      }],
      config: {
        loading: false
      },
      'row-key': row => {
        return row.programId;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name',
        minWidth: 260
      }, {
        label: '信息源ID',
        prop: 'sourceId',
        width: 130
      }, {
        label: '类型',
        prop: 'programType',
        width: 100,
        formatter: value => TYPE_OPTION[value]
      }, {
        label: '审核状态',
        width: 150,
        prop: 'auditStatus',
        cellSlot: true
      }, {
        label: '上线状态',
        width: 150,
        prop: 'releaseStatus',
        cellSlot: true
      }, {
        label: '语言',
        prop: 'audioLanguage',
        width: 156
      }, {
        label: '编码协议',
        prop: 'videoCode',
        minWidth: 150
      }, {
        label: '分类属性',
        prop: 'genres',
        minWidth: 230
      }, {
        label: '操作用户',
        prop: 'operatorName',
        minWidth: 150
      }, {
        label: '创建时间',
        prop: 'createTime',
        width: 160,
        formatter: val => val && getCurrentTime(val)
      }]
    });
    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 获取列表


    const getReviewList = async () => {
      try {
        !tableConfig.config.loading ? tableConfig.config.loading = true : '';
        let params = { ...searchData,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...searchConfig.formData,
          // 过滤上一步选择的运营商
          cpspId: Number(sessionStorage.getItem('currentCpspid')),
          // 下面的参数用于区别列表，已经添加过的节目不再返回,编辑时使用
          listType: 3,
          videoSeriesId: props.detailInfo ? props.detailInfo.id : undefined
        };

        if (params.time && params.time.length) {
          params.startTime = params.time[0];
          params.endTime = params.time[1];
          delete params.time;
        }

        const res = await getReviewListApi(removePropertyOfNull(params));

        if (res.code == '0') {
          tableConfig.data = res.data.records;
          tableConfig.paginationConfig.total = res.data.total;
          tableConfig.config.loading = false;
        } else {
          tableConfig.config.loading = false;
        }

        !props.detailInfo && selectTableConfig.selectData.forEach(row => {
          tableRef.value.commonTableRef.toggleRowSelection(row, true);
        });
      } catch (error) {
        console.log('357err', error);
        tableConfig.config.loading = false;
      }

      oldGenresList.value = JSON.parse(JSON.stringify(genresList.value));
    }; // 获取运营商


    const getOperatorList = async () => {
      tableConfig.config.loading = true;

      try {
        if (useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1) {
          const res = await getOperatorNameListApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'cpspId');
            item.list = res.data;
          }
        }

        let currentCpspid = sessionStorage.getItem('currentCpspid');
        searchConfig.formData.cpspId = currentCpspid ? Number(currentCpspid) : useCommon().userData.cpspid || 0;
        sessionStorage.setItem('currentCpspid', String(searchConfig.formData.cpspId));
      } catch (error) {
        tableConfig.config.loading = false;
      }
    }; // 获取操作用户


    const getUserByCid = async params => {
      if (useCommon().userData.permissionKey.indexOf('DC_OU') > -1) {
        const cid = sessionStorage.getItem('currentCid');
        const res = await getUserByCidApi({
          cid
        });

        if (res.code == '0') {
          let item = getItemByProp(searchConfig.formList, 'operatingUser');
          item.list = [{
            agentName: t('全部'),
            id: ''
          }, ...res.data.sort(function (a, b) {
            return a.agentName.trim().localeCompare(b.agentName.trim());
          })];
        }
      }

      return;
    };

    getUserByCid();
    const genresList = ref([]); // 分类属性数据缓存,避免下拉切换造成视图数据影响

    const oldGenresList = ref([]); // 获取分类属性

    const getGenres = async () => {
      const res = await useGenresList(localStorage.getItem('language') || 'en', searchConfig.formData.programType || 'movie');
      let item = getItemByProp(searchConfig.formList, 'genresId');
      item.list = [{
        name: t('全部'),
        id: ''
      }, ...res];
      genresList.value = res;
    };

    getGenres(); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      let languageList = getItemByProp(searchConfig.formList, 'language');
      languageList.list = [{
        label: t('全部'),
        value: '',
        labelValue: ''
      }, ...res];
    };

    getAllLanguages(); // 搜索查询

    const handleSearch = searchData => {
      getReviewList();
    }; // 重置


    const handleReset = () => {
      tableConfig.paginationConfig.page = 1;
      searchConfig.formData = {
        cid: Number(sessionStorage.getItem('currentCid')),
        keyword: '',
        genresId: '',
        language: '',
        programType: 'movie',
        time: '',
        codingProtocol: '',
        operatingUser: '',
        auditStatus: '',
        releaseStatus: '',
        cpspId: Number(sessionStorage.getItem('currentCpspid'))
      };
      getReviewList();
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["size", "form-list", "form-data"]), _createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(Buttons, {
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_TableColumnOptionBtn, {
        "column-list": columnConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])]), _createVNode(_component_common_table, {
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getReviewList,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'releaseStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle('color:' + _unref(RELEASE_COLOR_NEW)[scope.row.releaseStatus])
          }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 5)) : _createCommentVNode("", true), scope.column.property === 'auditStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle('color:' + _unref(AUDIT_COLOR_NEW)[scope.row.auditStatus])
          }, _toDisplayString(_unref(AUDIT_STATUS_NEW)[scope.row.auditStatus]), 5)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config"])])])), [[_directive_loading, tableConfig.config.loading]])])]), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%'
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, null, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});